/* eslint-disable */
import { Box, Typography } from '@mui/material'
import FormLayout from '../FormLayout'
import { useForm } from 'react-hook-form'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import Checkbox from '../../Checkbox'
import DividerTAG from '../../DividerTAG'
import { ICaseType, ICaseTypeForm, ICaseTypesObject } from './types'
import reportsService from '../../../services/reportsService'
import { useSelector } from 'react-redux'
import reportsSelectors from '../../../store/reports/reportsSelectors'
import { ICaseTypeDTO } from '../../../store/reports/types'
import textUtils from '../../../utils/textUtils'

const CaseTypeForm: React.FC<ICaseTypeForm> = ({
                                                 updateNumberOfChanges,
                                                 submitFunctions,
                                                 previewOnly = false,
                                               }) => {
  const [data, setData] = useState<React.ReactNode[]>([])
  const [changes, setChanges] = useState(0)
  // const [canEdit, setCanEdit] = useState(false);
  const selectedReportTypes = useSelector(reportsSelectors.reportCaseTypes)
  const formMethods = useForm<any>({
    defaultValues: [],
    mode: 'onChange',
    shouldFocusError: false,
  })
  const { watch, control, reset, getValues, formState } = formMethods
  const { dirtyFields } = formState
  const changesNumber = Object.keys(dirtyFields).length

  const submitHandler = () => {
    const currentValues = getValues()
    // extract only ids from types where value is true
    const selectedIds = Object.values(currentValues as ICaseTypesObject)
        .filter((item: ICaseType) => item?.value)
        .map(trueValues => trueValues?.id)

    return [1, 2, ...selectedIds]
  }

  submitFunctions.submitCaseTypes = submitHandler

  useEffect(() => {
    if (changesNumber === changes) return
    setChanges(changesNumber)
    updateNumberOfChanges(changesNumber - changes)
  }, [changesNumber])

  // useEffect(() => {
  //   setCanEdit(!previewOnly);
  // }, [previewOnly]);
  const getData = async () => {
    const { data } = await reportsService.getReportTypes()
    const formatedData: ICaseTypesObject = data
        .filter(
            (caseType: { text: string }) =>
                caseType?.text !== 'ALL' && caseType?.text !== 'REPORTER' && caseType?.text !== 'OSHA',
        )
        .reduce((acc: ICaseTypesObject, obj: ICaseTypeDTO) => {
          acc[obj.text] = {
            label: obj?.text,
            value: false,
            subtypes: obj?.subtypes,
            id: obj?.id,
          }
          return acc
        }, {})
    Object.values(formatedData).forEach(value => {
      if (selectedReportTypes?.map(type => type?.id).includes(value.id)) {
        value.value = true
      }
    })
    reset(
        { ...formatedData },
        {
          keepDirty: true,
          keepDirtyValues: true,
        },
    )
  }

  const memoizedSelectedReportTypes = useMemo(() => selectedReportTypes, [selectedReportTypes])
  useEffect(() => {
    getData()
  }, [memoizedSelectedReportTypes])
  
  const renderCheckboxes = useCallback(
    (formData: any) => {
        // console.log('previewOnly', previewOnly)
        const nodesToRender = Object.keys(formData).map((key, index) => {
          return (
              <Box sx={{ display: 'flex', flexDirection: 'column' }} key={`${key}+${index}`}>
                <Checkbox
                    control={control}
                    fieldName={`${key}.value`}
                    value={formData[key]?.value}
                    label={textUtils.humanize(formData[key]?.label)}
                    previewOnly={previewOnly}
                />
                {formData[key].value &&
                    formData[key].subQuestions &&
                    Object.keys(formData[key].subQuestions).map((subKey, subIndex) => {
                      return (
                          <Box
                              sx={{ display: 'flex', flexDirection: 'column', paddingLeft: '2rem' }}
                              key={`${subKey}+${subIndex}`}
                          >
                            <Checkbox
                                control={control}
                                fieldName={`${key}.subQuestions[${subKey}].value`}
                                value={formData[key].subQuestions[subKey].value}
                                label={textUtils.humanize(formData[key].subQuestions[subKey].label)}
                                previewOnly={previewOnly}
                            />
                          </Box>
                      )
                    })}
                <DividerTAG />
              </Box>
          )
        })
        setData(nodesToRender)
      },
      [watch, previewOnly],
  )

  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      renderCheckboxes(value)
    })

    return () => subscription.unsubscribe()
  }, [watch, previewOnly])
  return (
      <>
        <FormLayout>
          <Typography variant='labelBold'>Select All That Apply</Typography>
          <DividerTAG />
          {data}
        </FormLayout>
      </>
  )
}

export default CaseTypeForm
